export const Models = [
    {
        name: 'models_name_AR2E',
        size: 'TAMANY2',
        value: 5,
        desc: 'models_desc_gradoIII',
        height:500,
        width:450,
        deep:450,
        weight:210
    },
    {
        name: 'models_name_AR3E',
        size: 'TAMANY3',
        value: 7,
        desc: 'models_desc_gradoIII',
        height:650,
        width:550,
        deep:550,
        weight:340
    },
    {
        name: 'models_name_AR4E',
        size: 'TAMANY4',
        value: 9,
        desc: 'models_desc_gradoIII',
        height:800,
        width:550,
        deep:550,
        weight:400
    },
    {
        name: 'models_name_AR5E',
        size: 'TAMANY5',
        value: 11,
        desc: 'models_desc_gradoIII',
        height:950,
        width:550,
        deep:550,
        weight:460
    },
    {
        name: 'models_name_AR6E',
        size: 'TAMANY6',
        value: 13,
        desc: 'models_desc_gradoIII',
        height:1100,
        width:550,
        deep:550,
        weight:520
    },
    {
        name: 'models_name_AR7E',
        size: 'TAMANY7',
        value: 15,
        desc: 'models_desc_gradoIII',
        height:1250,
        width:550,
        deep:550,
        weight:580
    },
    {
        name: 'models_name_AP2E',
        size: 'TAMANY2',
        value: 5,
        desc:'models_desc_gradoIV',
        height:500,
        width:450,
        deep:450,
        weight:215
    },
    {
        name: 'models_name_AP3E',
        size: 'TAMANY3',
        value: 7,
        desc:'models_desc_gradoIV',
        height:650,
        width:550,
        deep:550,
        weight:350
    },
    {
        name: 'models_name_AP4E',
        size: 'TAMANY4',
        value: 9,
        desc:'models_desc_gradoIV',
        height:800,
        width:550,
        deep:550,
        weight:410
    },
    {
        name: 'models_name_AP5E',
        size: 'TAMANY5',
        value: 11,
        desc:'models_desc_gradoIV',
        height:950,
        width:550,
        deep:550,
        weight:475
    },
    {
        name: 'models_name_AP6E',
        size: 'TAMANY6',
        value: 13,
        desc:'models_desc_gradoIV',
        height:1100,
        width:550,
        deep:550,
        weight:535
    },
    {
        name: 'models_name_AP7E',
        size: 'TAMANY7',
        value: 15,
        desc:'models_desc_gradoIV',
        height:1250,
        width:550,
        deep:550,
        weight:600
    }
]
